import { createIcon } from "@chakra-ui/icons";

// Created from layers.svg

export const InspectIcon = createIcon({
  displayName: "Inspect",
  viewBox: "0 0 17 17",
  path: (
    <g>
      <path
        d="M5.62 16.5L0.5 0.5L16.5 6.26L8.18 8.82L5.62 16.5Z"
        stroke="currentColor"
        fill="transparent"
        strokeLinejoin="round"
      />
    </g>
  ),
});
